import { render, staticRenderFns } from "./CarNumberSearchDetail.vue?vue&type=template&id=5674903e&scoped=true"
import script from "./CarNumberSearchDetail.vue?vue&type=script&lang=js"
export * from "./CarNumberSearchDetail.vue?vue&type=script&lang=js"
import style0 from "./CarNumberSearchDetail.vue?vue&type=style&index=0&id=5674903e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5674903e",
  null
  
)

export default component.exports